
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Check } from "lucide-react";

interface SuccessStateProps {
  isAuthenticated: boolean;
}

const SuccessState = ({ isAuthenticated }: SuccessStateProps) => {
  return (
    <section className="py-8 bg-gradient-to-b from-background to-muted/20">
      <div className="container px-4">
        <Card className="max-w-md mx-auto text-center">
          <CardContent className="pt-8 pb-6">
            <div className="flex items-center justify-center w-16 h-16 bg-green-500/10 rounded-full mx-auto mb-4">
              <Check className="w-8 h-8 text-green-500" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Request Created!</h3>
            <p className="text-muted-foreground text-sm">
              {isAuthenticated ? "Redirecting to your conversation..." : "Redirecting to preview..."}
            </p>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default SuccessState;
